export const CREATE_SUPPORT_TICKET_REQUEST = "CREATE_SUPPORT_TICKET_REQUEST";
export const CREATE_SUPPORT_TICKET_SUCCESS = "CREATE_SUPPORT_TICKET_SUCCESS";
export const CREATE_SUPPORT_TICKET_FAILURE = "CREATE_SUPPORT_TICKET_FAILURE";


export const GET_SUPPORT_TICKET_REQUEST = 'GET_SUPPORT_TICKET_REQUEST';
export const GET_SUPPORT_TICKET_SUCCESS = 'GET_SUPPORT_TICKET_SUCCESS';
export const GET_SUPPORT_TICKET_FAILURE = 'GET_SUPPORT_TICKET_FAILURE';

export const GET_SUPPORT_TICKET_DETAIL_REQUEST = 'GET_SUPPORT_TICKET_DETAIL_REQUEST';
export const GET_SUPPORT_TICKET_DETAIL_SUCCESS = 'GET_SUPPORT_TICKET_DETAIL_SUCCESS';
export const GET_SUPPORT_TICKET_DETAIL_FAILURE = 'GET_SUPPORT_TICKET_DETAIL_FAILURE';

export const POST_SUPPORT_TICKET_COMMENT_REQUEST = "POST_SUPPORT_TICKET_COMMENT_REQUEST";
export const POST_SUPPORT_TICKET_COMMENT_SUCCESS = "POST_SUPPORT_TICKET_COMMENT_SUCCESS";
export const POST_SUPPORT_TICKET_COMMENT_FAILURE = "POST_SUPPORT_TICKET_COMMENT_FAILURE";

export const UPDATE_SUPPORT_TICKET_STATUS_REQUEST = "UPDATE_SUPPORT_TICKET_STATUS_REQUEST";
export const UPDATE_SUPPORT_TICKET_STATUS_SUCCESS = "UPDATE_SUPPORT_TICKET_STATUS_SUCCESS";
export const UPDATE_SUPPORT_TICKET_STATUS_FAILURE = "UPDATE_SUPPORT_TICKET_STATUS_FAILURE";